function rem() {
    var w = null;
    w = document.getElementsByTagName("html")[0];
    if (!(w.clientWidth > 1200 || w.clientWidth < 750)) {
        w.style.fontSize = 100 * (w.clientWidth / 1200) + "px";
    } else {
        if (w.clientWidth <= 750) {
            w.style.fontSize = 100 * (w.clientWidth / 750) + "px";
        }
    };
};
rem();

window.addEventListener("resize", rem, false);
